import { render, staticRenderFns } from "./EventInvitation.vue?vue&type=template&id=650260df&"
import script from "./EventInvitation.vue?vue&type=script&lang=js&"
export * from "./EventInvitation.vue?vue&type=script&lang=js&"
import style0 from "./EventInvitation.vue?vue&type=style&index=0&id=650260df&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports